export default __webpack_public_path__ + "static/media/varunji.baa2f906.jpg";